var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import "core-js";
import Vue from "vue";
import { getCultureCookieValue } from '@/common/utils/cookieUtilities';
import { initializeI18n } from './initializeI18n';
import { initializeLoginAppI18n } from './initializeLoginAppI18n';
import { appId, storeInLocalStorage, shutdownLocalStorageApps } from './appId';
import { extend, localize, configure } from "vee-validate";
import sv from "vee-validate/dist/locale/sv.json";
import fi from 'vee-validate/dist/locale/fi.json';
import { max, min, required, numeric, digits, is } from 'vee-validate/dist/rules';
import { withinRange, businessId, bothNotFalse, notNullOption, businessIdExists, organisationWithoutAdmin, phone, postalCode, name, organisationName, min_value, max_value, realEstateId, monthYearDate, laterThanStrDate, earlierThanStrDate, iban, fullDate, email, shareGroupId, stringsMatchConfirm, emailIsNotTaken, password } from '@/common/validators/veevalidators';
import { setInteractionMode } from 'vee-validate';
import { BootstrapVue } from 'bootstrap-vue';
// This should be later changed back to vue-multiselect, once version 3.x (or a previous one) with accessibility changes is released.
import Multiselect from "vue-multiselect-accessibility";
import VueRouter from 'vue-router';
import VueNumeric from "nettix-vue-numeric";
import VueI18n from 'vue-i18n';
import MobileDetect from 'mobile-device-detect';
import store from "./store/store";
import { getRouter } from "./router/router";
import { getLoginAppRouter } from "../loginApp/template/router/router";
import { mapGetters } from "vuex";
import ResourcesService from "@/common/services/resourcesService";
import AuthenticationService from "@/common/services/authenticationService";
import ConfigurationsService from "@/common/services/ConfigurationsService";
import FileUpload from 'vue-upload-component';
import App from "./App.vue";
import LoginApp from "./LoginApp.vue";
import { formatDate, formatDatetime } from "@/common/filters/formatDate";
import { formatPercentage } from "@/common/filters/formatPercentage";
import { formatNumber } from "@/common/filters/formatNumber";
import { toUpperCase } from "@/common/filters/toUpperCase";
import { shutdown } from "@/common/utils/eventHandlers";
import { CookiePolicy } from '@/common/types/CookiePolicy';
import CookieContainer from "@/common/types/CookieContainer";
import moment from "moment";
import VueMatomo from 'vue-matomo';
Vue.config.performance = true;
polyfill();
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
// Component doesn't have typings so needs to be installed this way.
var VTooltip = require('v-tooltip');
var tooltipOptions = {};
if (MobileDetect.isMobile) {
    tooltipOptions = { "autoHide": false, "defaultTrigger": 'click' };
}
else {
    tooltipOptions = { "autoHide": false };
}
Vue.use(VTooltip, tooltipOptions);
Vue.component("multiselect", Multiselect);
Vue.component("vue-numeric", VueNumeric);
Vue.component('file-upload', FileUpload);
// Install finnish and swedish VeeValidate localizations.
localize({
    fi: fi,
    sv: sv
});
Vue.filter("truncate", function (value, beginLimit, endLimit) {
    var tail = "...";
    var endLimitValue = endLimit ? endLimit : 0;
    var text = value;
    if (text && text.length > beginLimit + endLimitValue) {
        text = text.substring(0, beginLimit).trim();
        text = text + tail;
        text = text + value.substring(value.length - endLimitValue, value.length).trim();
    }
    return text;
});
Vue.filter("tailing", function (value, tail) {
    return value ? value + tail : value;
});
Vue.filter(formatNumber.id, formatNumber.definition);
Vue.filter("formatDecimalNumber", function (value) {
    return value ? Math.round(value * 10) / 10 : value;
});
Vue.filter(formatDate.id, formatDate.definition);
Vue.filter(formatDatetime.id, formatDatetime.definition);
Vue.filter(toUpperCase.id, toUpperCase.definition);
Vue.filter(formatPercentage.id, formatPercentage.definition);
initializeConfiguration()
    .then(function (config) {
    initializeCookiePolicy(config);
    return config;
})
    .then(function (config) { return initializeApp(config); });
function initializeCookiePolicy(config) {
    return __awaiter(this, void 0, void 0, function () {
        var policy;
        return __generator(this, function (_a) {
            policy = new CookiePolicy(config);
            policy.enforce();
            store.commit("vuexPageModule/SET_COOKIEPOLICY", policy);
            return [2 /*return*/];
        });
    });
}
function checkAuthentication() {
    return __awaiter(this, void 0, Promise, function () {
        var authService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authService = new AuthenticationService();
                    return [4 /*yield*/, authService.isAuthenticated()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function checkProcuration() {
    return __awaiter(this, void 0, Promise, function () {
        var authService, currentUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authService = new AuthenticationService();
                    return [4 /*yield*/, authService.getCurrentUser()];
                case 1:
                    currentUser = _a.sent();
                    return [2 /*return*/, currentUser.hasProcuration];
            }
        });
    });
}
/**
 *
 * Initialize Vue application
 *
 **/
function initializeApp(config) {
    return __awaiter(this, void 0, void 0, function () {
        var hasAuth;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkAuthentication()];
                case 1:
                    hasAuth = _a.sent();
                    if (!hasAuth) return [3 /*break*/, 3];
                    return [4 /*yield*/, initializeAuthenticatedApp(config)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, initializeLoginApp(config)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
function initializeAuthenticatedApp(config) {
    return __awaiter(this, void 0, void 0, function () {
        var lang, resourceService, i18n, hasProcuration_1, router_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, initilizeBackend()];
                case 1:
                    _a.sent();
                    lang = getCultureCookieValue();
                    resourceService = new ResourcesService();
                    return [4 /*yield*/, initializeI18n(resourceService, lang)];
                case 2:
                    i18n = _a.sent();
                    return [4 /*yield*/, checkProcuration()];
                case 3:
                    hasProcuration_1 = _a.sent();
                    initializeVeeValidate(i18n);
                    router_1 = getRouter(config);
                    router_1.beforeEach(function (to, from, next) {
                        if (to.path == "/sessionExpired") {
                            next();
                            return;
                        }
                        if (to.meta.procurationOnly && !hasProcuration_1) {
                            router_1.push("/");
                            next();
                            return;
                        }
                        if (from.path == "/sessionExpired") {
                            router_1.push("/sessionExpired");
                            next();
                            return;
                        }
                        //App.ts check is user authenticated
                        next();
                    });
                    initializeVue(i18n, router_1, config);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error('Failed to initialize Vue Authed', e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function initializeLoginApp(config) {
    return __awaiter(this, void 0, void 0, function () {
        var lang, resourceService, i18n, router, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, addSessionExpirationCookie()];
                case 1:
                    _a.sent();
                    lang = getCultureCookieValue();
                    resourceService = new ResourcesService();
                    return [4 /*yield*/, initializeLoginAppI18n(resourceService, lang)];
                case 2:
                    i18n = _a.sent();
                    initializeVeeValidate(i18n);
                    router = getLoginAppRouter();
                    router.beforeEach(function (to, from, next) {
                        // Tarvitaanko t�h�n jotain?
                        next();
                    });
                    initializeLoginAppVue(i18n, router, config);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error('Failed to initialize Vue Login', e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function addSessionExpirationCookie() {
    return __awaiter(this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            value = moment(new Date()).add(7, 'days').utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
            CookieContainer.set("SessionExpires", encodeURIComponent(value), 7, null, null, true, "Lax");
            return [2 /*return*/];
        });
    });
}
/**
 *
 * 'Touch' the back-end service end-point which checks that the user is authenticated.
 *
 **/
function initilizeBackend() {
    return __awaiter(this, void 0, Promise, function () {
        var authService, authOk, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    authService = new AuthenticationService();
                    return [4 /*yield*/, authService.isAuthenticated()];
                case 1:
                    authOk = _b.sent();
                    return [2 /*return*/, authOk];
                case 2:
                    _a = _b.sent();
                    throw new Error('Failed to authenticate');
                case 3: return [2 /*return*/];
            }
        });
    });
}
function initializeConfiguration() {
    return __awaiter(this, void 0, Promise, function () {
        var configuration, configService, config, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    configuration = null;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configService = new ConfigurationsService();
                    return [4 /*yield*/, configService.getSettings()];
                case 2:
                    config = _a.sent();
                    store.commit("vuexPageModule/SET_CONFIGURATION", config);
                    configuration = config;
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    store.commit("vuexPageModule/SET_CONFIGURATION", null);
                    console.error(e_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, configuration];
            }
        });
    });
}
/**
 *
 * Register validations and map localized error messages
 *
 **/
function initializeVeeValidate(i18n) {
    configure({
        defaultMessage: function (field, values) {
            // 'field' contains the value of the name attribute of the active ValidationProvider
            return i18n.t("Validation." + values._rule_, values);
        }
    });
    extend("required", required);
    extend("min_value", min_value);
    extend("max_value", max_value);
    extend("minlength", min);
    extend("maxlength", max);
    extend("is", is);
    extend("within", withinRange);
    extend("laterStr", laterThanStrDate);
    extend("earlierStr", earlierThanStrDate);
    extend("email", email);
    extend("emailnottaken", emailIsNotTaken);
    extend("numeric", numeric);
    extend("businessId", businessId);
    extend("businessIdExists", businessIdExists);
    extend("organisationWithoutAdmin", organisationWithoutAdmin);
    extend("phone", phone);
    extend("postalCode", postalCode);
    extend("name", name);
    extend("organisationName", organisationName);
    extend("shareGroupId", shareGroupId);
    extend("realEstateId", realEstateId);
    extend("digits", digits);
    extend("monthYearDate", monthYearDate);
    extend("fullDate", fullDate);
    extend("iban", iban);
    extend("bothNotFalse", bothNotFalse);
    extend("notNullOption", notNullOption);
    extend("passwordConfirm", stringsMatchConfirm);
    extend("emailConfirm", stringsMatchConfirm);
    extend("password", password);
    // 'eager' first validation lazily, then aggressively
    setInteractionMode('eager');
}
/**
 *
 *  Mount the Vue app
 *
 **/
function initializeVue(i18n, router, config) {
    Vue.use(VueMatomo, {
        host: config.matomoPath,
        siteId: config.matomoSiteId,
        requireConsent: true,
        enableLinkTracking: true,
    });
    new Vue({
        store: store,
        router: router,
        i18n: i18n,
        render: function (h) { return h(App); },
        computed: __assign({}, mapGetters("vuexpage-module", [
            "loading"
        ])),
        beforeCreate: function () {
            // When starting to create the app, initialize the app id and run shutdown
            // on all apps whose ids are in local storage.
            store.commit("vuexPageModule/SET_APPID", appId);
            shutdownLocalStorageApps();
            window.addEventListener('beforeunload', function (e) {
                // When moving out of the site (by changing the url, F5 or browser/tab close)
                // persist the current app id in local storage and attempt to perform shutdown.
                storeInLocalStorage(appId);
                store.commit("vuexPageModule/START_SHUTDOWN");
                shutdown(appId);
            });
        },
        beforeDestroy: function () {
            // When unloading the Asiointi vue app, persist the current app id in local storage
            // and attempt to perform shutfown.
            storeInLocalStorage(appId);
            store.commit("vuexPageModule/START_SHUTDOWN");
            shutdown(appId);
        }
    }).$mount("#app");
}
/**
*
*  Mount the login app Vue
*
**/
function initializeLoginAppVue(i18n, router, config) {
    Vue.use(VueMatomo, {
        host: config.matomoPath,
        siteId: config.matomoSiteId,
        requireConsent: true,
        enableLinkTracking: true,
    });
    new Vue({
        store: store,
        router: router,
        i18n: i18n,
        render: function (h) { return h(LoginApp); },
        computed: __assign({}, mapGetters("vuexpage-module", [
            "loading"
        ]))
    }).$mount("#app");
}
